export const isCompanyDuplicate = (
  companyList: { companyId: string; name: string }[],
  name: string,
  excludeCompanyId?: string
): boolean =>
  companyList.some((company) => {
    if (excludeCompanyId && company.companyId === excludeCompanyId) return false
    return company.name.toLowerCase().trim() === name.toLowerCase().trim()
  })
